import React from "react";
import type { FailureAggregation } from "./useFailureAggregation";
import { useFailureAggegation, failureAggregationOptions } from "./useFailureAggregation";
import ReportingChartMenu from "../../ReportingChartMenu";

function FailureAggregationSelector() {
  const [selectedFailureAggregation, setFailureAggregation] = useFailureAggegation({});

  return (
    <ReportingChartMenu<FailureAggregation>
      options={failureAggregationOptions}
      currentValue={selectedFailureAggregation}
      setCurrentValue={setFailureAggregation}
    />
  );
}

export default React.memo(FailureAggregationSelector);
